import {
    ReelsCascadingBasicState,
    ReelsCascadingFillInSymbolsState,
    ReelsCascadingInitState,
    ReelsCascadingReleaseSymbolsState,
    ReelsCascadingStates,
    ReelsCascadingCollapseState
} from '@gongxigames/framework/slot/modules/reelsCascading';

export const ReelsCascadingStatesMap = {
    [ReelsCascadingStates.INIT_STATE]: ReelsCascadingInitState,
    [ReelsCascadingStates.BASIC_STATE]: ReelsCascadingBasicState,
    [ReelsCascadingStates.RELEASE_SYMBOLS_STATE]: ReelsCascadingReleaseSymbolsState,
    [ReelsCascadingStates.FILL_IN_STATE]: ReelsCascadingFillInSymbolsState,
    [ReelsCascadingStates.COLLAPSE]: ReelsCascadingCollapseState
};